import { createApp, vue } from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/scss/main.scss'
import { setup } from './utils/permissions'
import api from '@/api'
import '@vant/touch-emulator'
import VueClipboards from 'vue-clipboard2'
import { addErrorLog } from '@/utils/errorLog'
import 'default-passive-events' //加了这个会导致 vant 自带事件组件滑动选择时间的时候报错  *Unable to preventDefault inside passive*
// import Vconsole from 'vconsole'
// let VConsole  = new Vconsole
import {
  Button,
  Image as VanImage,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Picker,
  Popup,
  Checkbox,
  CheckboxGroup,
  Icon,
  Calendar,
  Uploader,
  Cell,
  DatetimePicker,
  ActionSheet,
  Dialog,
  Loading,
  Tabbar,
  TabbarItem,
  List,
  PullRefresh,
  Lazyload,
  NavBar,
  Tag,
  Tab,
  Tabs,
  Search,
  Empty,
  Step,
  Steps,
  Swipe,
  SwipeItem,
  NoticeBar,
  Sticky,
  Rate,
  ImagePreview,
  NumberKeyboard,
  Overlay,
} from 'vant'
setup()
const app = createApp(App)
// app.use(VConsole)
/**
 * 全局跳转函数
 * @author hanson.liu
 * @date 2021-10-23
 * @param {any} name 路由name
 * @param {any} opt 路由参数 {params:{id:xxxx}} || {query:{id:xxxx}}
 * @param {any} type='push' 路由跳转模式 默认push 可选值replace
 * @returns {any}
 */

app.config.globalProperties.$go = (name, opt = {}, type = 'push') => {
  router[type](Object.assign(opt, { name }))
}
app.config.globalProperties.$getAvatar = (url) => {
  let res = null
  if (url) {
    res = api.FileHost + url
  } else {
    res = require('@/assets/images/logo.png')
  }
  return res
}

app.config.errorHandler = addErrorLog

app.use(store)
app.use(router)
app.use(Button)
app.use(VanImage)
app.use(Form)
app.use(Field)
app.use(CellGroup)
app.use(Radio)
app.use(RadioGroup)
app.use(Picker)
app.use(Popup)
app.use(Checkbox)
app.use(CheckboxGroup)
app.use(Icon)
app.use(Calendar)
app.use(Uploader)
app.use(Cell)
app.use(DatetimePicker)
app.use(ActionSheet)
app.use(Dialog)
app.use(Loading)
app.use(Tabbar)
app.use(TabbarItem)
app.use(List)
app.use(PullRefresh)
app.use(Lazyload)
app.use(NavBar)
app.use(Tag)
app.use(Tab)
app.use(Tabs)
app.use(Search)
app.use(Empty)
app.use(Step)
app.use(Steps)
app.use(VueClipboards)
app.use(Swipe)
app.use(SwipeItem)
app.use(NoticeBar)
app.use(Sticky)
app.use(Rate)
app.use(ImagePreview)
app.use(NumberKeyboard)
app.use(Overlay)
app.mount('#app')
